import config from 'src/config';
import engineApiSlice from 'src/shared/state/api-slices/engineApiSlice';
import { executeEngineQuery } from 'src/app/portfolio/state/api/engineQueryUtils';
import type { GqlRiskBandLevel, GqlSonBandLevel } from 'src/app/portfolio/state/api/riskInsightsEngineSlice';
import { getPortfolioNatureStatusQuery, type GetPortfolioNatureStatusResult } from './portfolioNatureStatusQuery';

const portfolioNatureStatusSlice = engineApiSlice.injectEndpoints({
    endpoints: builder => ({
        getPortfolioNatureStatus: builder.query<
            GetPortfolioNatureStatusResult,
            {
                businessCentralId: string;
                at?: string;
                isic?: string[];
                countries?: string[];
                physicalRiskLevels?: GqlRiskBandLevel[];
                dependencyLevels?: GqlRiskBandLevel[];
                impactLevels?: GqlRiskBandLevel[];
                sonLevels?: GqlSonBandLevel[];
            }
        >({
            queryFn: arg =>
                executeEngineQuery<GetPortfolioNatureStatusResult>(
                    `${config.engineApiUrl.replace(/\/$/, '')}/query`,
                    getPortfolioNatureStatusQuery,
                    {
                        businessCentralId: arg.businessCentralId,
                        at: arg.at,
                        isic: arg.isic ?? [],
                        countries: arg.countries ?? [],
                        physicalRiskLevels: arg.physicalRiskLevels ?? [],
                        dependencyLevels: arg.dependencyLevels ?? [],
                        impactLevels: arg.impactLevels ?? [],
                        sonLevels: arg.sonLevels ?? [],
                    }
                ),
            providesTags: (_result, _error, arg) => [{ type: 'organisation' as const, id: arg.businessCentralId }],
        }),
    }),
});

export const { useGetPortfolioNatureStatusQuery } = portfolioNatureStatusSlice;

export default portfolioNatureStatusSlice;
